// extracted by mini-css-extract-plugin
export default {"group":"IntegrationOption_group__BHUcF"};